var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.55978 29H14.71C17.087 29 18.2124 27.8016 18.2124 25.4164V23.305H20.4516C22.8173 23.305 24 22.1066 24 19.7213V10.1688C24 8.76504 23.7244 7.87485 22.8631 6.99604L17.0641 1.12986C16.2373 0.296732 15.2842 0 14.0555 0H9.35884C6.99326 0 5.799 1.19837 5.799 3.58362V5.69498H3.55978C1.19425 5.69498 0 6.89335 0 9.27865V25.4164C0 27.8131 1.19425 29 3.55978 29ZM18.2124 16.2176C18.2124 14.7568 18.0402 14.1177 17.1215 13.1818L10.7942 6.77922C9.92152 5.88902 9.19804 5.69498 7.90046 5.69498H7.6478V3.60646C7.6478 2.48799 8.26791 1.83746 9.4507 1.83746H14.2966V7.80639C14.2966 9.11884 14.9512 9.75793 16.2603 9.75793H22.1513V19.6985C22.1513 20.8284 21.5426 21.4675 20.3483 21.4675H18.2124V16.2176ZM16.5359 8.10312C16.1225 8.10312 15.9617 7.93191 15.9617 7.53249V2.20265L21.7952 8.10312H16.5359ZM3.65164 27.1625C2.46885 27.1625 1.8488 26.5234 1.8488 25.3821V9.30144C1.8488 8.18302 2.46885 7.53249 3.6631 7.53249H7.6478V14.1519C7.6478 15.5899 8.38275 16.2975 9.80668 16.2975H16.3636V25.3821C16.3636 26.5234 15.7435 27.1625 14.5493 27.1625H3.65164ZM10.0248 14.5742C9.56554 14.5742 9.38181 14.3916 9.38181 13.9465V7.88624L16.0076 14.5742H10.0248Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.005ba70adf934c1d6e3ae1bdb24e116d.svg";
export { ForwardRef as ReactComponent };